import React from "react";
import "./button.scss";

interface ButtonProps {
  disabled: boolean;
  children: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  buttonType: "primary" | "secondary" | "tertiary" | "danger";
  size: "small" | "medium" | "large";
}

export function Button(props: ButtonProps) {
  const buttonClass = `btn-${props.buttonType}-${props.size}`;
  return (
    <>
      <button
        disabled={props.disabled}
        onClick={props.onClick}
        className={buttonClass}
      >
        {props.children}
      </button>
    </>
  );
}
